import React from 'react';
import * as PortalApi from '../lib/portal-api';

const defaultState: PortalApi.TokenViewModel = {
  isAuthenticated: false,
};

export const TokenContext =
  React.createContext<PortalApi.TokenViewModel>(defaultState);

export class TokenContextProvider extends React.Component {
  state = defaultState;

  async componentDidMount(): Promise<void> {
    // this.setState({isAuthenticated: true, accessToken: "abcdef"});
    const tokenResponse = await PortalApi.getToken();
    this.setState(tokenResponse);
  }

  render(): React.ReactNode {
    return (
      <TokenContext.Provider value={this.state}>
        {this.props.children}
      </TokenContext.Provider>
    );
  }
}
